import { render, staticRenderFns } from "./DiscountBanner.vue?vue&type=template&id=52c1b2df&scoped=true&"
import script from "./DiscountBanner.vue?vue&type=script&lang=js&"
export * from "./DiscountBanner.vue?vue&type=script&lang=js&"
import style0 from "./DiscountBanner.vue?vue&type=style&index=0&id=52c1b2df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1b2df",
  null
  
)

export default component.exports